import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAppContext } from '../../../context';
import { apiUrl } from '../../../utils/config';

export default function Footer() {
  const navigate = useNavigate();
  const { storeSettings } = useAppContext();
  const storeName = storeSettings?.store_name || "Gamapa Foods";

  const [quickLinks, setQuickLinks] = useState([]);
  const [legalLinks, setLegalLinks] = useState([]);

  useEffect(() => {
    axios
      .get(`${apiUrl}/nav-links/public?location=footer`)
      .then((res) => {
        const list = res.data?.list || [];
        setQuickLinks(list.filter((l) => l.group === "quick_links"));
        setLegalLinks(list.filter((l) => l.group === "legal"));
      })
      .catch(() => {});
  }, []);

  const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener noreferrer");
    } else {
      navigate(url);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-black text-xl text-white">{storeName.toUpperCase()}</span>
            </div>
            <p className="text-sm leading-relaxed mb-6 max-w-xs">
              {storeSettings?.store_tagline || "Authentic cuisine delivered fresh to your doorstep. Made with love, served with tradition."}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => handleClick(link.url)}
                    className="hover:text-orange-400 transition-colors text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              {quickLinks.length === 0 && (
                <li className="text-gray-600 text-xs">No links configured</li>
              )}
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <h4 className="font-bold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              {legalLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => handleClick(link.url)}
                    className="hover:text-orange-400 transition-colors text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              {legalLinks.length === 0 && (
                <li className="text-gray-600 text-xs">No links configured</li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {new Date().getFullYear()} {storeName}. All rights reserved.</p>
          <div className="flex items-center gap-2">
            <span>We accept:</span>
            {["Visa", "Mastercard", "UPI", "NetBanking"].map((m) => (
              <span key={m} className="bg-gray-800 px-2 py-1 rounded text-[10px]">{m}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
